export default {
      id: "download-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#download-usage",
      toString: function () {
        return this.url;
      }
    }